import { httpPost } from "../httpService/httpService";

let _file: any, 
    _guid: any, 
    _baseUrl: any, 
    _progressCallback: any, 
    _finishedCallback: any, 
    _notFinishedCallback: any;

let start: any, 
    end: any, 
    chunkNumber: any, 
    totalChunks: any, 
    totalSize: any, 
    paused = false, 
    isCanceled = false, 
    inProgress = false;

const chunkSize: any = 1048576;  // ~ 1 MB

export const startChunkUpload = (file: File, baseUrl: string, progressCallback: any, finishedCallback: any, notFinishedCallback: any) => {
    if (inProgress) return;

    inProgress = true;
    isCanceled = false;
    
    _file = file;
    _guid = null;
    _baseUrl = baseUrl;
    _progressCallback = progressCallback;
    _finishedCallback = finishedCallback;
    _notFinishedCallback = notFinishedCallback;
    
    start = 0;
    chunkNumber = 1;
    totalSize = file.size;
    totalChunks = Math.ceil(totalSize / chunkSize);

    createChunk();
}

const createChunk = () => {
    httpPost(`${_baseUrl}/create-upload-chunk`)
    .then((res: any) => {
        _guid = res.data;
        sendChunk();
    })
    .catch((error) => {
        cancelChunkUpload();
        if (_notFinishedCallback) _notFinishedCallback(error.message);
    })
}

const sendChunk = () => {
    end = start + chunkSize;

    if (totalSize - end < 0) {
        end = totalSize;
    }

    let chunk = _file.slice(start, end);

    const formData = new FormData();
    formData.append('chunk', chunk);
    formData.append('chunkNumber', chunkNumber);
    formData.append('chunkSize', chunkSize);
    formData.append('totalSize', totalSize);
    formData.append('fileName', _file.name);
    formData.append('totalChunks', totalChunks);

    httpPost(`${_baseUrl}/${_guid}/upload-chunk`, formData)
    .then((res) => {
        if (end < totalSize) {
            if (isCanceled) {
                const callbackResponse = { isCanceled: isCanceled, guid: _guid }
                if (_finishedCallback) _finishedCallback(callbackResponse);
                isCanceled = false;
            }
            if (!inProgress) return;
            if (paused) return;
            if (_progressCallback) _progressCallback(Math.ceil((chunkNumber / totalChunks) * 10));

            start += chunkSize;
            chunkNumber++;
            sendChunk();
        } 
        else {
            const callbackResponse = { isCanceled: isCanceled, fileName: res.data, guid: _guid }
            if (_finishedCallback) _finishedCallback(callbackResponse);
            inProgress = false;
            _guid = null;
        }
    })
    .catch((error) => {
        paused = true;
        cancelChunkUpload();
        if (_notFinishedCallback) _notFinishedCallback(error.message);
    })
}

export const cancelChunkUpload = () => {
    inProgress = false;
    paused = false;
    isCanceled = true;
    if (_guid) {
        httpPost(`${_baseUrl}/${_guid}/cancel-upload`, _guid);
    }
}